import type { FunctionComponent } from "react";

import { weHaveSoMuchForYouItems } from "./data";
import {
  Container,
  Description,
  Header,
  ItemContainer,
  StyledWeHaveSoMuchForYouItem,
} from "./styles";

export const WeHaveSoMuchForYou: FunctionComponent = () => (
  <Container>
    <Header>Get even more with Posties</Header>
    <Description>Make learning fun with our awesome activities</Description>
    <ItemContainer>
      {weHaveSoMuchForYouItems.map((item, index) => (
        <StyledWeHaveSoMuchForYouItem {...item} key={index} />
      ))}
    </ItemContainer>
  </Container>
);

WeHaveSoMuchForYou.displayName = "WeHaveSoMuchForYou";
